import { AppDispatch } from "../../redux/store";
import { T } from "react-translator-component";
import { reset } from "../redux/adminAuthReducer";
import setAuthToken from "../../services/axios-util/set-auth-token";
import { adminRoles } from "../constants/adminUsers";

export const formatNumber = (value?: number | string) => {
  let v = value
  if (v == null) {
    return ''
  }
  if (typeof v === 'string') {
    v = Number(v);
  }
  if (isNaN(v)) {
    return ''
  }
  return v.toLocaleString()
}

export const unauthrizedError = (resStatusCode: number, dispatch: AppDispatch) => {
  if (resStatusCode !== 401) return

  setTimeout(() => {
    dispatch(reset());
    setAuthToken("__");
  }, 1000);

  return T("mng_session_timeout");
}

export const isSuperAdmin = (adminUser: any) => {
  return adminUser?.class_name === 'AdminUser' && adminUser?.role === adminRoles.superAdmin
};

export const isAdmin = (adminUser: any) => {
  return adminUser?.class_name === 'AdminUser' && (adminUser?.role === adminRoles.admin || isSuperAdmin(adminUser))
};

export const isNavigator = (adminUser: any) => {
  return adminUser?.class_name === 'AdminUser' && adminUser?.role === adminRoles.navigator
}

const createCsvBlob = (props: {headers: string[], fieldNames: string[], data: any[]}) => {
  const {headers, fieldNames, data} = props

  const csvRows: string[] = [];
  csvRows.push(headers.map((header: string) => `"${header}"`).join(","));

  for (const item of data) {
    const values = fieldNames.map((key: string) => {
      if (!item[key]) return '""';
      const str = item[key].replace(/"/g, '""');
      return `"${str}"`
    });
    csvRows.push(values.join(","));
  }
  const csvString = csvRows.join("\r\n");

  const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
  const blob = new Blob([bom, csvString], { type: "text/csv;charset=utf-8;" });

  return blob
}

export const downloadCsv = (props: {filename: string, headers: string[], fieldNames: string[], data: any[]}) => {
  const {filename, headers, fieldNames, data} = props
  const blob = createCsvBlob({headers: headers, fieldNames: fieldNames, data: data});

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
